import { render, staticRenderFns } from "./SetEmployeeLeave.vue?vue&type=template&id=646edb26&scoped=true"
import script from "./SetEmployeeLeave.vue?vue&type=script&lang=js"
export * from "./SetEmployeeLeave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646edb26",
  null
  
)

export default component.exports